import * as Yup from 'yup';
import { Country } from '@tiendanube/common/src/enums';
import { validateCNPJ, validateCPF } from 'domains/Billing/utils';

const discountsRule = {
  [Country.BR]: Yup.string()
    .typeError('errors.empty')
    .required('errors.empty')
    .test('is-valid-id', 'errors.empty', function (value) {
      if (typeof value !== 'string') return false;

      const length = value.length;

      if (length === 0) {
        return (
          validateCNPJ(value) ||
          this.createError({
            message: 'errors.empty',
          })
        );
      }

      if (length !== 11 && length !== 14) {
        return this.createError({
          message: 'errors.invalid',
        });
      }
      if (length === 14) {
        return (
          validateCNPJ(value) ||
          this.createError({
            message: 'errors.invalid',
          })
        );
      }
      if (length === 11) {
        return (
          validateCPF(value) ||
          this.createError({
            message: 'errors.invalid',
          })
        );
      }
      return false;
    }),
  [Country.AR]: Yup.string()
    .required('errors.empty')
    .matches(/^[0-9]+$/, 'errors.empty')
    .test('is-valid-id', 'errors.empty', function (value) {
      if (typeof value !== 'string') return false;

      if (value.length === 0) {
        return this.createError({ message: 'errors.empty' });
      }
      if (value.length !== 11) {
        return this.createError({ message: 'errors.invalid' });
      }
      return true;
    }),
  [Country.MX]: Yup.string()
    .required('errors.empty')
    .test('is-valid-rfc', 'errors.invalid', function (value) {
      if (typeof value !== 'string') return false;
      if (value.length === 0) {
        return this.createError({ message: 'errors.empty' });
      }

      const upperValue = value.toUpperCase();

      // Regular expression that validates RFC for legal entities (12 characters) or individuals (13 characters)
      const rfcRegex =
        /^(?:[A-Z&Ñ]{3}\d{6}[A-Z0-9]{3}|[A-Z&Ñ]{4}\d{6}[A-Z0-9]{3})$/;

      if (!rfcRegex.test(upperValue)) {
        return this.createError({ message: 'errors.invalid' });
      }
      return true;
    }),
};

export const getValidationSchema = (country: Country) =>
  Yup.object().shape({
    document: discountsRule[country],
  });
